// 登録の途中で止まっているか（2026-11-02）。
// SMS の確認まで済ませて名前・住所を入れる前に戻った人は、拠点がまだ無い（lpspot_id=0）。Now の拠点は住所から決まるので、
// ホームに来たら登録の続き（/register/profile）へ送る。以前はホームの商品メニューが拠点なしで読めず、例外になっていた（11/1 お客様1063）。
// API が lpspot_id を返さない古い版のときは送らない（全員を登録へ送ってしまわないように）
export function needsRegisterResume(customer) {
  if (!customer || !Object.prototype.hasOwnProperty.call(customer, 'lpspot_id')) return false;
  return !(Number(customer.lpspot_id) > 0);
}
